import { render, staticRenderFns } from "./basic-view.vue?vue&type=template&id=0dbd0090&scoped=true&"
import script from "./basic-view.vue?vue&type=script&lang=ts&"
export * from "./basic-view.vue?vue&type=script&lang=ts&"
import style0 from "./basic-view.vue?vue&type=style&index=0&id=0dbd0090&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbd0090",
  null
  
)

export default component.exports